/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Icon, LinearProgress, Pagination, Paper, Snackbar, Dialog, DialogTitle, DialogContent, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Typography, useTheme, alpha, Button, Checkbox, Chip } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import dayjs from 'dayjs';
import { FaturamentoService, IListagemFaturamento, IGetItensFaturamento } from '../../../shared/services/api/Financeiro/Faturamento';
import { FerramentasDaListagemFaturamento } from '../../../shared/components';
import { DialogFaturameto } from './DialogFaturamento';
import { Dialogsendnfce } from './Dialogsendnfce';
import { DialogNFE } from './Dialogsendnfe';
import { DialogFaturar } from './DialogsendFaturar';

export const ListagemFaturamento: React.FC = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const [rows, setRows] = useState<IListagemFaturamento[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [istexto, setIsTexto] = useState(false);
  const [selectedTipo, setSelectedTipo] = useState<number | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [openDialogConfirmarCPF, setOpenDialogConfirmarCPF] = useState(false);
  const [incluirCpf, setIncluirCpf] = useState<boolean | null>(null);
  const [selected, setSelected] = useState<string>('');
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedNome, setSelectedNome] = useState<string>('');
  const [selectedTotal, setSelectedTotal] = useState<number>(0);
  const [selectedNumeroDocumento, setSelectedNumeroDocumento] = useState<number>(0);
  const [selectedEmissaoData, setSelectedEmissaoData] = useState<string>('');
  const [selecteTpag, setSelectedTpag] = useState<number>();
  const [selectedParceiro, setSelectedParceiro] = useState<string | null>(null);
  const [openDialogFaturamento, setOpenDialogFaturamento] = useState(false);
  const [openDialognfe, setOpenDialognfe] = useState(false);
  const [openDialogFaturar, setOpenDialogFaturar] = useState(false);
  const [openDialogPagamento, setOpenDialogPagamento] = useState(false);
  const [movimentoData, setMovimentoData] = useState<IGetItensFaturamento[]>([]);
  const [openConfirmFaturar, setOpenConfirmFaturar] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);
  const basicselect = useMemo(() => {
    return searchParams.get('basicselect') || 'r.idparceiro';
  }, [searchParams]);
  const basicstatus = useMemo(() => {
    return searchParams.get('basicstatus') || 'false';
  }, [searchParams]);
  const parceiroselect = useMemo(() => {
    return searchParams.get('parceiroselect') || '';
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    if (!openDialogConfirmarCPF) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        const noButton = document.getElementById('btn-nao') as HTMLButtonElement;
        const yesButton = document.getElementById('btn-sim') as HTMLButtonElement;

        if (document.activeElement === noButton) {
          yesButton.focus();
        } else {
          noButton.focus();
        }
      }
      if (event.key === 'Enter') {
        const active = document.activeElement as HTMLButtonElement;
        if (active?.id === 'btn-nao') handleConfirmarCpf(false);
        if (active?.id === 'btn-sim') handleConfirmarCpf(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [openDialogConfirmarCPF]);
  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      FaturamentoService.getAll(pagina)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setRows(result.data);
            setSelectedId('');
          }
        });
    });
  }, [busca, pagina, refreshKey]);
  const refreshList = () => {
    setRefreshKey(prev => prev + 1);
    setSelectedId(null);
    setSelectedParceiro(null);
    setSelected('');
  };
  const formatarCPF = (cpf: string) => {
    if (!cpf) return '';
    const cpfLimpo = cpf.replace(/\D/g, '');
    if (cpfLimpo.length === 11) {
      return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return cpf;
  };
  const handleSelectItem = (
    id: string,
    idparceiro: string,
    nome: string,
    tpag: number,
    total: number,
    numero: number,
    emissao: string,
    tipo: number
  ) => {
    setSelectedId(prevSelectedId => prevSelectedId === id ? null : id);
    setSelectedParceiro(prev => prev === idparceiro ? null : idparceiro);
    setSelected(id);
    setSelectedNome(nome);
    setSelectedTpag(tpag);
    setSelectedTotal(total);
    setSelectedNumeroDocumento(numero);
    setSelectedEmissaoData(emissao);
    setSelectedTipo(tipo);
  };
  const handleRowClick = async (id: string) => {
    try {
      setIsLoading(true);
      const resultado = await FaturamentoService.getByIdFaturamento(id);
      if (resultado instanceof Error) {
        setTms('error');
        setMsg(resultado.message);
        setOpenmsg(true);
      } else if (Array.isArray(resultado)) {
        setMovimentoData(resultado);
        setOpenDialogFaturamento(true);
      } else {
        setTms('warning');
        setMsg('Formato de dados inválido');
        setOpenmsg(true);
      }
    } catch (error) {
      setTms('error');
      setMsg('Erro ao carregar dados do faturamento');
      setOpenmsg(true);
    } finally {
      setIsLoading(false);
    }
  };
  const handleFaturarSelecionado = async () => {

    if (!selectedId) {
      setTms('warning');
      setMsg('Selecione um item para faturar');
      setOpenmsg(true);
      return;
    }
    if (selecteTpag === 1) {
      setOpenDialogFaturar(true);
      return;
    }
    if (selecteTpag === 2) {
      setOpenConfirmFaturar(true);
      return;
    }
  };

  const confirmarFaturamento = async () => {
    try {
      setOpenConfirmFaturar(false);
      setIsLoading(true);
      const payload = {
        idmov: selectedId || '',
        datapgto: dayjs().format('YYYY-MM-DD'),
      };
      const result = await FaturamentoService.createfaturarid(payload);
      if (result instanceof Error) {
        setTms('error');
        setMsg(result.message);
      } else {
        setTms('success');
        setMsg('Lançamento realizado com sucesso!');
        refreshList();
      }
      setOpenmsg(true);
      setSelectedId('');
    } catch (error) {
      setTms('error');
      setMsg('Erro inesperado ao faturar.');
      setOpenmsg(true);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSendNFCE = async () => {
    if (!selectedId) {
      setTms('warning');
      setMsg('Selecione um item para faturar');
      setOpenmsg(true);
      return;
    }
    setOpenDialogConfirmarCPF(true);
  };
  const handleSendNFE = async () => {
    setOpenDialognfe(true);
  };
  const handleConfirmarCpf = (resposta: boolean) => {
    setIncluirCpf(resposta);
    setOpenDialogConfirmarCPF(false);
    setOpenDialogPagamento(true);
  };
  return (
    <>

      <LayoutBaseDePagina
        titulo='Faturamento'
        barraDeFerramentas={
          <Box sx={{ width: '100%', margin: 1 }}>
            <FerramentasDaListagemFaturamento
              aoClicarEmFaturamento={handleFaturarSelecionado}
              aoClicarEmNFCE={handleSendNFCE}
              desabilitarNFCE={selectedTipo === 1}
              desabilitarNFE={selectedTipo === 1}
              aoClicarEmNFE={handleSendNFE}
              isLoading={false}
            />
          </Box>
        }
      >
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={openmsg}
          autoHideDuration={null}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
          }}
        >
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{
              width: '100%',
              maxWidth: '500px',
              '& .MuiAlert-action': {
                paddingTop: 0,
                alignItems: 'center'
              }
            }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={handleCloseMsg}
                sx={{
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.8rem',
                  borderRadius: 1,
                  px: 2,
                  py: 0.5,
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.25)',
                  }
                }}
              >
                OK
              </Button>
            }
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                {tms === 'error' ? 'Erro' :
                  tms === 'warning' ? 'Atenção' :
                    tms === 'success' ? 'Sucesso' : 'Informação'}
              </Typography>
              <Typography variant="body2">
                {msg}
              </Typography>
            </Box>
          </Alert>
        </Snackbar>
        <Box sx={{
          p: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '200px',
          width: '100%',
          boxSizing: 'border-box',
        }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              background: theme.palette.background.paper,
              height: rows.length === 0 ? '200px' : 'auto',
              maxHeight: 'calc(100vh - 200px)',
            }}
          >
            <TableContainer
              sx={{
                flex: 1,
                overflow: 'auto',
                width: '100%',
                minHeight: '120px',
                maxHeight: rows.length > 10 ? 'calc(100vh - 280px)' : 'none',
              }}
            >
              <Table
                size="medium"
                sx={{
                  width: '100%',
                  tableLayout: 'fixed',
                  minWidth: 800,
                }}
              >
                <TableHead>
                  <TableRow sx={{
                    backgroundColor: theme.palette.mode === 'dark'
                      ? alpha(theme.palette.primary.dark, 0.1)
                      : alpha(theme.palette.primary.main, 0.04),
                  }}>
                    <TableCell align='center' sx={{
                      width: '5%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Seleção
                    </TableCell>
                    <TableCell align='center' sx={{
                      width: '10%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Emissão
                    </TableCell>
                    <TableCell align='center' sx={{
                      width: '10%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Número
                    </TableCell>
                    <TableCell align='left' sx={{
                      width: '30%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Parceiro
                    </TableCell>
                    <TableCell align='center' sx={{
                      width: '15%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      CPF
                    </TableCell>
                    <TableCell align='right' sx={{
                      width: '15%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Total
                    </TableCell>
                    <TableCell align='center' sx={{
                      width: '15%',
                      py: 1,
                      fontWeight: 600,
                      color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
                      fontSize: '0.78rem',
                      borderBottom: `2px solid ${alpha(theme.palette.divider, 0.2)}`
                    }}>
                      Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => {
                    const isSelected = row.idmov === selectedId;
                    return (
                      <TableRow
                        key={row.idmov}
                        hover
                        selected={isSelected}
                        sx={{
                          cursor: 'pointer',
                          backgroundColor: isSelected
                            ? alpha(theme.palette.primary.main, 0.08)
                            : index % 2 === 0
                              ? 'transparent'
                              : alpha(theme.palette.action.hover, 0.02),
                          '&:hover': {
                            backgroundColor: isSelected
                              ? alpha(theme.palette.primary.main, 0.12)
                              : alpha(theme.palette.action.hover, 0.04)
                          },
                          '&:last-child td': { borderBottom: 0 }
                        }}
                        onClick={() => handleRowClick(row.idmov)}
                      >
                        <TableCell
                          align='center'
                          sx={{ py: 1, px: 0.5 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={isSelected}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                row.idmov,
                                row.idparceiro,
                                row.nome,
                                row.tpag,
                                row.total,
                                row.numero,
                                row.emissao,
                                row.tipo
                              );
                            }}
                            value={row.idmov}
                            name="faturamento-checkbox"
                            inputProps={{ 'aria-label': `Selecionar faturamento ${row.numero}` }}
                            size="small"
                            sx={{
                              color: theme.palette.primary.main,
                              '&.Mui-checked': {
                                color: theme.palette.primary.main,
                              },
                            }}
                          />
                        </TableCell>

                        <TableCell align='center' sx={{ py: 1, px: 0.5, fontSize: '0.76rem' }}>
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: alpha(theme.palette.primary.main, 0.1),
                              borderRadius: 1,
                              px: 0.8,
                              py: 0.3,
                              color: theme.palette.primary.dark,
                              fontSize: '0.76rem'
                            }}
                          >
                            {dayjs(row.emissao).format('DD/MM/YY')}
                          </Box>
                        </TableCell>

                        <TableCell align='center' sx={{
                          py: 1,
                          px: 0.5,
                          fontFamily: 'monospace',
                          fontSize: '0.76rem',
                          fontWeight: 500,
                          color: theme.palette.text.primary
                        }}>
                          {row.numero}
                        </TableCell>

                        <TableCell align='left' sx={{
                          py: 1,
                          px: 0.5,
                          fontSize: '0.76rem',
                          maxWidth: 0,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                          {row.nome}
                        </TableCell>

                        <TableCell align='center' sx={{
                          py: 1,
                          px: 0.5,
                          fontFamily: 'monospace',
                          fontSize: '0.76rem',
                          color: theme.palette.text.secondary
                        }}>
                          {formatarCPF(row.cpf)}
                        </TableCell>

                        <TableCell align='right' sx={{
                          py: 1,
                          px: 0.5,
                          fontFamily: 'monospace',
                          fontSize: '0.78rem',
                          fontWeight: 600,
                          color: theme.palette.success.main
                        }}>
                          {Number(row.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </TableCell>

                        <TableCell align='center' sx={{ py: 1, px: 0.5 }}>
                          <Chip
                            label={
                              row.tipo === 1
                                ? 'Entrada'
                                : row.tipo === 3
                                  ? 'Devolução'
                                  : 'Venda'
                            }
                            size="small"
                            color={
                              row.tipo === 1
                                ? 'info'
                                : row.tipo === 3
                                  ? 'warning'
                                  : 'success'
                            }
                            variant="outlined"
                            sx={{
                              borderRadius: 1,
                              fontSize: '0.7rem',
                              height: 20
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {totalCount === 0 && !isLoading && (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      <Box display="flex" flexDirection="column" alignItems="center">
                        <Icon sx={{ fontSize: 48, color: 'text.secondary', mb: 1, opacity: 0.5 }}>receipt</Icon>
                        <Typography variant="h6" color="text.secondary" gutterBottom fontSize="1rem">
                          {Environment.LISTAGEM_VAZIA}
                        </Typography>
                        <Typography variant="body2" color="text.disabled" fontSize="0.8rem">
                          Nenhum registro de faturamento encontrado
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </TableContainer>

            <DialogFaturameto
              id="detalhes"
              value=""
              open={openDialogFaturamento}
              status={true}
              movimentoData={movimentoData}
              onDados={(dados) => {

              }}
              onClose={() => setOpenDialogFaturamento(false)}
            />
            <DialogFaturar
              id={selectedId ?? ''}
              open={openDialogFaturar}
              parceiroNome={selectedNome}
              valorTotal={selectedTotal}
              onClose={() => {
                setOpenDialogFaturar(false);
                refreshList();
              }}
            />
            <Dialog
              open={openDialogConfirmarCPF}
              onClose={() => setOpenDialogConfirmarCPF(false)}
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  p: 1,
                  background: theme.palette.mode === 'dark'
                    ? alpha(theme.palette.background.paper, 0.95)
                    : alpha(theme.palette.background.default, 0.98),
                  boxShadow: theme.shadows[10],
                  minWidth: 340,
                },
              }}
            >
              <DialogTitle
                sx={{
                  textAlign: 'center',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  color: theme.palette.primary.main,
                  pb: 0.5,
                }}
              >
                Incluir CPF na nota?
              </DialogTitle>

              <DialogContent
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                  py: 2,
                }}
              >
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ fontSize: '0.95rem', mb: 1 }}
                >
                  Deseja incluir o CPF do cliente na NFC-e?
                </Typography>

                {/* Botões de escolha */}
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 1,
                  }}
                >
                  <Button
                    id="btn-nao"
                    variant="contained"
                    color="error"
                    onClick={() => handleConfirmarCpf(false)}
                    sx={{
                      minWidth: 100,
                      fontWeight: 600,
                      borderRadius: 2,
                      transition: '0.2s',
                      boxShadow: (theme) =>
                        alpha(theme.palette.error.main, 0.3) + ' 0px 2px 6px',
                    }}
                    autoFocus
                  >
                    Não
                  </Button>
                  <Button
                    id="btn-sim"
                    variant="outlined"
                    color="primary"
                    onClick={() => handleConfirmarCpf(true)}
                    sx={{
                      minWidth: 100,
                      fontWeight: 600,
                      borderRadius: 2,
                      transition: '0.2s',
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                      },
                    }}
                  >
                    Sim
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
            <Dialogsendnfce
              selectedId={selectedId}
              selectedtpag={selecteTpag}
              open={openDialogPagamento}
              parceironome={selectedNome}
              valortotal={selectedTotal}
              numerodocumento={selectedNumeroDocumento}
              emissaodata={selectedEmissaoData}
              onClose={() => {
                setOpenDialogPagamento(false);
                refreshList();
              }}
              incluirCpf={incluirCpf ?? false}
            />
            <DialogNFE
              selectedId={selectedId}
              selectedtpag={selecteTpag}
              idpar={selectedParceiro}
              parceironome={selectedNome}
              valortotal={selectedTotal}
              numerodocumento={selectedNumeroDocumento}
              emissaodata={selectedEmissaoData}
              open={openDialognfe}
              onClose={() => {
                setOpenDialognfe(false);
                refreshList();
              }}
            /><Dialog
              open={openConfirmFaturar}
              onClose={() => setOpenConfirmFaturar(false)}
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  p: 2,
                  minWidth: 360,
                  textAlign: 'center'
                }
              }}
            >
              <DialogTitle sx={{ fontWeight: 700 }}>
                Confirmar Faturamento
              </DialogTitle>

              <DialogContent>
                <Typography sx={{ mb: 2 }}>
                  Deseja realmente faturar esta venda?
                </Typography>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Parceiro:</strong> {selectedNome}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Valor:</strong>{' '}
                    {selectedTotal.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                  <Button
                    variant="outlined"
                    color="inherit"
                    onClick={() => setOpenConfirmFaturar(false)}
                  >
                    Cancelar
                  </Button>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={confirmarFaturamento}
                  >
                    Confirmar
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
            {(totalCount > 0 || isLoading) && (
              <Box
                sx={{
                  borderTop: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                  backgroundColor: theme.palette.mode === 'dark'
                    ? alpha(theme.palette.background.paper, 0.9)
                    : theme.palette.background.paper,
                  p: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {isLoading && (
                  <LinearProgress
                    variant="indeterminate"
                    sx={{ position: 'absolute', top: 0, left: 0, right: 0 }}
                  />
                )}

                {(totalCount > 0 && totalCount > 10) && (
                  <TableRow>
                    <TableCell colSpan={6} sx={{
                      py: 1.5,
                      borderTop: `1px solid ${theme.palette.mode === 'dark'
                        ? alpha(theme.palette.divider, 0.2)
                        : alpha(theme.palette.divider, 0.1)}`,
                      backgroundColor: theme.palette.mode === 'dark'
                        ? alpha(theme.palette.background.default, 0.7)
                        : alpha(theme.palette.grey[50], 0.2)
                    }}>
                      <Box display='flex' justifyContent='center' alignItems='center'>
                        <Pagination
                          page={pagina}
                          count={Math.ceil(totalCount / 10)}
                          onChange={(_, newPage) => setSearchParams({
                            busca: busca,
                            basicstatus: basicstatus,
                            basicselect: basicselect,
                            parceiroselect: parceiroselect,
                            pagina: newPage.toString()
                          }, { replace: true })}
                          color='primary'
                          size="small"
                          shape='rounded'
                          showFirstButton
                          showLastButton
                          sx={{
                            '& .MuiPaginationItem-root': {
                              fontWeight: 'bold',
                              color: theme.palette.text.primary,
                              fontSize: '0.75rem',
                              minWidth: '28px',
                              height: '28px',
                              backgroundColor: theme.palette.mode === 'dark'
                                ? alpha(theme.palette.background.paper, 0.7)
                                : undefined,
                              '&:hover': {
                                backgroundColor: theme.palette.mode === 'dark'
                                  ? alpha(theme.palette.primary.main, 0.25)
                                  : undefined
                              },
                              '&.Mui-selected': {
                                backgroundColor: theme.palette.mode === 'dark'
                                  ? alpha(theme.palette.primary.main, 0.4)
                                  : undefined,
                                color: theme.palette.mode === 'dark'
                                  ? theme.palette.common.white
                                  : undefined
                              }
                            }
                          }}
                        />
                      </Box>
                      <Box textAlign="center" mt={0.5}>
                        <Typography variant="caption" color="text.secondary" fontSize="0.7rem">
                          Total de {totalCount} vendas
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </Box>
            )}

          </Paper>
        </Box>
      </LayoutBaseDePagina>
    </>
  );
};